import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = { children: ReactNode };
type State = { error: Error | null };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("[dataroom]", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="error-screen">
          <img className="error-screen__logo" src="/brand/spielmann-logo.svg" alt="Spielmann Consulting" />
          <h1>Something went wrong</h1>
          <p className="muted">{this.state.error.message || "An unexpected error occurred."}</p>
          <div className="row">
            <button type="button" onClick={() => this.setState({ error: null })}>
              Try again
            </button>
            <button type="button" className="secondary" onClick={() => window.location.assign("/")}>
              Back to dashboard
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
